
export default function VideoLayer ({layer, readOnly}) {

  return <>
    <video
      key={layer.id}
      src={layer.file.url}
      controls
      draggable="false"
      style={{
        height:   layer.height,
        width:    layer.width ,
        position: 'absolute',
      }}
    />
  </>
}
